import React, { useState, useEffect } from "react";
import path from "path";
import Resizer from "react-image-file-resizer";

import services from "../../services";
import moment from "moment";

import {
  adicionarArquivo,
  uploadArquivoAzure,
} from "../../services/http/arquivoServico";

import {
  criarPasta,
  verificarDuplacidade,
} from "../../services/http/pastaService";

import { uploadAzure } from "../../services/azureblobsService";

import { calcularTamanhoArquivo } from "../../services/utils";

import { Modal, Tree, message, Upload } from "antd";

import { SearchOutlined } from "@ant-design/icons";

import pastaSvg from "../../assets/icons/infoPasta.svg";
import pastaSvgFechada from "../../assets/icons/pasta-menu.svg";
import infoArquivoSvg from "../../assets/icons/infoArquivo.svg";
import iconNuvemArquivoSvg from "../../assets/icons/iconNuvemArquivo.svg";
import "./styles.scss";
import { v4 as uuidv4 } from "uuid";
import globals from "../../globlas";
import { CloseOutlined } from "@mui/icons-material";
import icAtencao from "../../assets/icons/atencaoIcon.svg";
import lang from "../../assets/idioma/idiomas";
const { Dragger } = Upload;
const AZURE_URL_BLOB = globals.REACT_APP_AZURE_URL_BLOB;

const ModalUpload = ({
  closeModal,
  showModal,
  destino,
  openModal,
  buscarPastasFilhas,
  setShowTreeData,
  setLoading,
  loading,
  setCloseOpenModal,
}) => {
  const data = new Date(); // momento atual
  const horas = data.getHours().toString();
  const minutos = data.getMinutes().toString();

  const hhmmm = [horas, minutos].join(":");

  const { IdUser, login, IsAdmin } = services.storage.getUser();
  const [progressoUpload, setProgressoUpload] = useState(0);
  const [showProgresso, setShowProgresso] = useState(false);
  const [showUpload, setShowUpload] = useState(true);
  const [uploadFinalizar, setUploadFinalizar] = useState(false);
  const [objetoFinalizar, setObjetoFinalizar] = useState(null);
  const [arquivoDuplicado, setArquivoDuplicado] = useState(false);
  const [botaoParamimTodos, setBotaoParamimTodos] = useState(Boolean);
  const [descricao, setDescricao] = useState("");
  const [dataVencimentoInicial, setDataVencimentoInicial] = useState(
    moment().format("YYYY-MM-DD")
  );
  const [dataVencimentoFinal, setDataVencimentoFinal] = useState("");
  const [horaInicial, setHoraInicial] = useState(hhmmm);
  const [horaFinal, setHoraFinal] = useState("");
  const [treeItens, setTreeItens] = useState([
    {
      title: destino ? destino.nome : lang.Nuvem_de_arquivos,
      key: destino ? destino.id : "0",
      icon: <img src={pastaSvgFechada} />,
    },
  ]);
  const [listaPastaArquivosCriados, setListaPastaArquivosCriados] = useState(
    []
  );
  const [listaArquivos, setListaArquivos] = useState([]);
  const [listaTotal, setListaTotal] = useState([]);
  const [count, setCount] = useState(1);

  const isFolderUpload = () => {
    return listaArquivos.some(
      (arquivo) => arquivo.path && arquivo.path.includes("/")
    );
  };

  useEffect(() => {
    setListaArquivos([]);
    setListaTotal([]);
    setShowProgresso(false);
    setObjetoFinalizar({});
    setListaPastaArquivosCriados([]);
  }, []);

  const handleUploadProgress = (e, total) => {
    setShowProgresso(true);
    let porcentagem = Math.floor((e * 100) / total);

    if (porcentagem >= 0) {
      setProgressoUpload(porcentagem);
    }
  };

  const finalizarUpload = async (publicarParaMim, substituir) => {
    setLoading(true);

    // validações
    var data_dataVencimentoInicial = dataVencimentoInicial;
    var data_dataVencimentoFinal = dataVencimentoFinal;

    if (!data_dataVencimentoInicial) {
      message.warning(lang.Informar_a_data_inicial);
      setLoading(false);
      return;
    }

    if (!data_dataVencimentoFinal && horaFinal) {
      message.warning(lang.Informar_a_data_final);
      setLoading(false);
      return;
    }

    if (horaInicial) data_dataVencimentoInicial += " " + horaInicial;

    if (data_dataVencimentoFinal && horaFinal)
      data_dataVencimentoFinal += " " + horaFinal;

    if (moment(data_dataVencimentoInicial).isAfter(data_dataVencimentoFinal)) {
      message.warning(lang.A_data_inicial_nao_pode_ser_maior_que_a_data_final);
      setLoading(false);
      return;
    }

    // início do processo
    setBotaoParamimTodos(publicarParaMim);

    const arrayArquivos = [];
    for (const arq of listaPastaArquivosCriados) {
      if (arq.nome.includes(".")) {
        arrayArquivos.push(arq);
      } else {
        // pasta
        const data = {
          id: arq.id,
          nomePasta: arq.nome,
          idParent: arq.idParent,
          classificacao: 0,
          autor: login,
          tamanho: 0,
          tipoDocumento: 0,
          EhUpload: true,
          dataVencimentoInicial: data_dataVencimentoInicial,
          dataVencimentoFinal: data_dataVencimentoFinal,
        };

        await criarPasta(data);
      }
    }

    for (const arquivo of arrayArquivos) {
      if (!substituir) {
        let ret = await verificarDuplacidade(
          arquivo.nome,
          arquivo.idParent ? arquivo.idParent : ""
        );

        if (ret?.data === true) {
          setArquivoDuplicado(true);
          setLoading(false);
          return;
        }
      }

      const data = {
        idPasta: arquivo.idParent,
        classificacao: 0,
        autor: login,
        tamanho: calcularTamanhoArquivo(arquivo.tamanho),
        nomeArquivo: arquivo.nome,
        urlArquivo: arquivo.urlArquivo,
        path: arquivo.path ? arquivo.path : null,
        extensao: arquivo.extensao,
        nomeOriginal: arquivo.nomeOriginal,
        descricao: descricao,
        tipoMidia: arquivo.tipo,
        urlPreview: arquivo.urlPreview,
        idUsuarioOcultou: publicarParaMim ? IdUser : null,
        dataVencimentoInicial: data_dataVencimentoInicial,
        dataVencimentoFinal: data_dataVencimentoFinal,
        tamanhoEmBytes: arquivo.tamanho,
      };

      await adicionarArquivo(data);
    }

    message.success(lang.Upload_finalizado_com_sucesso);
    setLoading(false);
    if (destino != null && destino.id != null) {
      buscarPastasFilhas(destino.id, "pasta", destino.nome);
    } else {
      buscarPastasFilhas("0", "pasta", "NuvemArquivo");
    }
    setShowTreeData(false);
    setTimeout(() => {
      setShowTreeData(true);
    }, 2);
    closeModal();
  };

  const selectItem = (e) => {
    const findArquivo = listaPastaArquivosCriados.find((item) => {
      return item.nome.includes(".") && item.nome == e;
    });

    if (findArquivo != null && findArquivo != undefined) {
      setObjetoFinalizar(findArquivo);
    }
  };

  const handleOnExpand = (e) => {};

  const updateTreeData = (list, key, children) => {
    return list.map((node) => {
      if (node.key === key) {
        return { ...node, children };
      }

      if (node.children) {
        return {
          ...node,
          children: updateTreeData(node.children, key, children),
        };
      }

      return node;
    });
  };

  const incluirNovaPasta = async (nome, idParent) => {
    const pastaJaCriadaIndex = listaPastaArquivosCriados.findIndex(
      (item) => item.nome == nome
    );

    if (pastaJaCriadaIndex >= 0) {
      return listaPastaArquivosCriados[pastaJaCriadaIndex].id;
    } else {
      var nomeTrim = nome.split("###")[0].trim();
      let data = {
        nomePasta: nomeTrim,
        idParent: idParent,
        classificacao: 0,
        autor: login,
        tamanho: 0,
        tipoDocumento: 0,
        idParent: idParent,
      };

      const res = await criarPasta(data);

      if (!res.fail && res.data) {
        let pastaCriada = {
          id: res.data.id,
          nome: nome,
          idParent: idParent,
        };

        listaPastaArquivosCriados.push(pastaCriada);
        setListaPastaArquivosCriados(listaPastaArquivosCriados);

        return pastaCriada.id;
      } else {
        console.error("criar-pasta-upload", res.errors);
      }
    }
  };

  const incluirNovoArquivo = (
    nome,
    idParent,
    tamanho,
    urlArquivo,
    path,
    tipo,
    nomeOriginal,
    extensao,
    urlPreview
  ) => {
    const arquivosJaCriadosIndex = listaPastaArquivosCriados.findIndex(
      (item) =>
        (item.nome == nome && item.idParent == idParent) ||
        (item.nome == nome && item.idParent == null)
    );

    if (arquivosJaCriadosIndex < 0) {
      let arquivoCriado = {
        id: nome,
        nome: nome,
        idParent: idParent,
        tamanho: tamanho,
        urlArquivo: urlArquivo,
        path: path,
        tipo: tipo,
        nomeOriginal: nomeOriginal,
        extensao: extensao,
        urlPreview: urlPreview,
      };

      listaPastaArquivosCriados.push(arquivoCriado);
      setListaPastaArquivosCriados(listaPastaArquivosCriados);
    }
  };

  const monstarUploadFinalizacao = async () => {
    let idParent = destino ? destino.id : null;
    const processedFolders = new Map(); // Track processed folders to avoid duplicates

    for (const arq of listaArquivos) {
      let arrayArqPastas = String(arq.nome).split("/");
      let currentParentId = idParent;

      // Process each folder in the path
      for (let i = 0; i < arrayArqPastas.length - 1; i++) {
        const folderName = arrayArqPastas[i];
        const folderKey = `${currentParentId}-${folderName}`;

        if (!processedFolders.has(folderKey)) {
          currentParentId = await incluirNovaPasta(folderName, currentParentId);
          processedFolders.set(folderKey, currentParentId);
        } else {
          currentParentId = processedFolders.get(folderKey);
        }
      }

      // Add the file with the correct parent ID
      const fileName = arrayArqPastas[arrayArqPastas.length - 1];
      if (fileName.includes(".")) {
        incluirNovoArquivo(
          arq.nomeOriginal,
          currentParentId,
          arq.tamanho,
          arq.urlArquivo,
          arq.path,
          arq.tipo,
          arq.nomeOriginal,
          arq.extensao,
          arq.urlPreview
        );
      }
    }

    setTimeout(() => {
      setUploadFinalizar(true);
      setShowProgresso(false);
      setShowUpload(false);
    }, 100);
  };

  const formatNomePasta = (nome) => {
    if (nome.length > 20) {
      return nome.slice(0, 20) + "...";
    }
    return nome;
  };
  const onLoadData = ({ key, children }) =>
    new Promise((resolve) => {
      if (children) {
        resolve();
        return;
      }
      if (key == "0") {
        setTimeout(() => {
          const array = [];
          listaPastaArquivosCriados.forEach((item) => {
            if (!item.idParent) {
              array.push({
                title: formatNomePasta(item.nome),
                key: item.id,
                isLeaf: item.nome.includes("."),
                icon: item.nome.includes(".") ? (
                  <img
                    className="icon-tree"
                    src={item.urlPreview ? item.urlPreview : infoArquivoSvg}
                  />
                ) : (
                  <img className="icon-tree" src={pastaSvg} />
                ),
              });
            }
          });
          setTreeItens((origin) => updateTreeData(origin, key, array));
          resolve();
        }, 2000);
      } else {
        setTimeout(() => {
          const array = [];
          listaPastaArquivosCriados.forEach((item) => {
            if (item.idParent == key) {
              array.push({
                title: formatNomePasta(item.nome),
                key: item.id,
                isLeaf: item.nome.includes("."),
                icon: item.nome.includes(".") ? (
                  <img
                    className="icon-tree"
                    src={item.urlPreview ? item.urlPreview : infoArquivoSvg}
                  />
                ) : (
                  <img className="icon-tree" src={pastaSvg} />
                ),
              });
            }
          });
          setTreeItens((origin) => updateTreeData(origin, key, array));
          resolve();
        }, 2000);
      }
    });

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const finalizar = async (listaTotal, listaNova) => {
    if (listaNova.length >= listaTotal.length) {
      await uploadArquivo();
    }
  };

  const uploadArquivo = async () => {
    let url;
    let pastaDestino = "nuvem_arquivo";

    if (destino) {
      pastaDestino = destino.id;
    }

    for (const arquivo of listaArquivos) {
      let index = listaArquivos.findIndex((item) => item.nome == arquivo.nome);
      setCount(index + 1);

      if (arquivo.tipo.includes("image")) {
        let response = await uploadArquivoAzure(
          arquivo.file,
          pastaDestino,
          300,
          300,
          handleUploadProgress
        );
        if (!response.fail && response.data) {
          var result = response.data;
          url = `${AZURE_URL_BLOB}${pastaDestino}/${result}`;
          var extensao = path.extname(arquivo.file.name);

          var original = path.basename(result, path.extname(result)) + extensao;
          original = url.replace(result, original).replace("THUMB_", "");
          atualizarListaArquivo(original, index, url);
        }
      } else {
        let response = await uploadAzure(
          arquivo.nome,
          arquivo.file,
          arquivo.tamanho,
          pastaDestino,
          handleUploadProgress
        );

        if (response._response.status == 201) {
          url = response._response.request.url;
          atualizarListaArquivo(url, index, null);
        }
      }
    }

    setTimeout(() => {}, 20);

    await monstarUploadFinalizacao();
  };

  const atualizarListaArquivo = (url, index, urlPreview) => {
    listaArquivos[index].urlArquivo = url;
    listaArquivos[index].urlPreview = urlPreview;
    setListaArquivos(listaArquivos);
  };

  const alterarImagem = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        300,
        300,
        "JPEG",
        100,
        0,
        (uri) => {
          return resolve(uri);
        },
        "file",
        100,
        100
      );
    });

  const propsDraggerPasta = {
    name: "pasta",
    multiple: true,
    directory: true,
    customRequest: dummyRequest,
    onChange: async ({ file }) => {
      if (file.status == "done") {
        let arquivo = {
          nome: file.originFileObj.webkitRelativePath
            ? file.originFileObj.webkitRelativePath
            : file.nome,
          tamanho: file.size,
          tipo: file.type,
          file: file.originFileObj,
          urlArquivo: "",
          path: file.originFileObj.webkitRelativePath,
          nomeOriginal: file.name,
          extensao: path.extname(file.name).slice(1),
        };

        listaArquivos.push(arquivo);
        setListaArquivos(listaArquivos);
        await finalizar(listaTotal, listaArquivos);
      }
    },
    onDrop(e) {},
  };

  const propsDraggerArquivo = {
    name: "arquivo",
    multiple: true,
    customRequest: dummyRequest,
    onChange: async ({ file }) => {
      if (file.status == "done") {
        let arquivo = {
          nome: file.originFileObj.webkitRelativePath
            ? file.originFileObj.webkitRelativePath
            : file.name,
          tamanho: file.size,
          tipo: file.type,
          file: file.originFileObj,
          urlArquivo: "",
          path: file.originFileObj.webkitRelativePath,
          nomeOriginal: file.name,
          extensao: path.extname(file.name).slice(1),
          urlPreview: null,
        };

        listaArquivos.push(arquivo);
        setListaArquivos(listaArquivos);
        await finalizar(listaTotal, listaArquivos);
      }
    },
    onDrop(e) {},
  };

  const handleBackgroundClick = (event) => {
    if (event.target.classList.contains("ant-modal-wrap") && showProgresso) {
      message.warning(
        "Tem certeza que deseja sair? Clique no X e o upload será cancelado."
      );
    }
  };

  function fecharModal() {
    if (showProgresso) {
      setCloseOpenModal(false);
      message.success(lang.Upload_cancelado_com_sucesso);
    }
  }

  function naoSubstituir() {
    closeModal();
  }
  return (
    <div onMouseDown={handleBackgroundClick}>
      <Modal
        title={
          uploadFinalizar && !arquivoDuplicado ? (
            <span className="modal-title-uplfinalizado ">
              {lang.Finalizando_o_upload}
            </span>
          ) : showProgresso ? (
            <span className="modal-title-uploadAndamento">
              {lang.Upload_em_andamento}
            </span>
          ) : (
            <span className="modal-title-upload"></span>
          )
        }
        visible={openModal}
        className={
          uploadFinalizar && !arquivoDuplicado
            ? "modal-novo"
            : showProgresso
            ? "modal-novo-uploadContagem"
            : arquivoDuplicado
            ? "modal-novo-lixeira"
            : "modal-novo-upload"
        }
        maskClosable={false}
        closable={false}
        footer={[
          <>
            {uploadFinalizar && !arquivoDuplicado && (
              <div className="buttons-finalizar-upload mt-4 mb-3">
                <button
                  onClick={async () => {
                    await finalizarUpload(true);
                  }}
                  className="button-publicar-mim-upload"
                  disabled={loading}
                >
                  {lang.Publicar_para_mim}
                </button>
                <button
                  onClick={async () => {
                    await finalizarUpload(false);
                  }}
                  className="button-publicar-todos-upload"
                  disabled={loading}
                >
                  {lang.Publicar_para_todos}
                </button>
              </div>
            )}
          </>,
        ]}
        destroyOnClose={true}
      >
        <CloseOutlined
          onClick={showProgresso ? fecharModal : closeModal}
          className="custom-close-icon"
        />
        <>
          {showUpload && (
            <div
              className="row"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Dragger
                {...propsDraggerPasta}
                beforeUpload={(file) =>
                  setListaTotal((prevent) => [...prevent, file])
                }
              >
                {showProgresso ? (
                  <span>
                    <span className="progresso-upload-contagem">
                      {progressoUpload}
                      <span>%</span>{" "}
                    </span>
                    <span className="upload-contagem">
                      {`Upload ${count} de ${listaTotal.length}`}
                    </span>
                  </span>
                ) : (
                  <>
                    <div>
                      <div>
                        <SearchOutlined className="search-icon" />
                      </div>
                      <div className="pesquisar-arquivo">
                        <div className="button-pesquisar">
                          {lang.Pesquisar_pasta}
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </Dragger>
              {!showProgresso && (
                <Dragger
                  {...propsDraggerArquivo}
                  beforeUpload={(file) =>
                    setListaTotal((prevent) => [...prevent, file])
                  }
                >
                  <div className="pesquisar-arquivo">
                    <div className="button-pesquisar">
                      {lang.Pesquisar_arquivo}
                    </div>
                  </div>
                </Dragger>
              )}
            </div>
          )}
        </>
        <>
          {uploadFinalizar && !arquivoDuplicado && (
            <div className="container-upload espacoUpload">
              <div className="itens-selecionados-upload  ">
                <div className="itens fundoGray">
                  <label>{lang.Destino}:</label>
                  <input
                    className="input-upload"
                    value={
                      destino != null ? destino.nome : lang.Nuvem_de_arquivos
                    }
                  />
                </div>
              </div>
              <div className="itens-importados">
                <span className="titulo-impotados">
                  {lang.Arquivos_Importados}
                </span>
                <div>
                  <Tree
                    className="lista-pastas"
                    showIcon
                    loadData={onLoadData}
                    onSelect={selectItem}
                    onExpand={handleOnExpand}
                    treeData={treeItens}
                  />
                </div>
              </div>
              <div className="p-5">
                <div className="row label-input">
                  <div className="col-md-3">
                    <label>{lang.Inicio}</label>
                    <input
                      disabled={IsAdmin.toLocaleLowerCase() != "true"}
                      type="date"
                      onChange={(e) =>
                        setDataVencimentoInicial(
                          moment(e.target.value).format("YYYY-MM-DD")
                        )
                      }
                      value={moment(dataVencimentoInicial).format("YYYY-MM-DD")}
                      style={{ width: "100%" }}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>{lang.Inicio}</label>
                    <input
                      disabled={IsAdmin.toLocaleLowerCase() != "true"}
                      type="time"
                      onChange={(e) => setHoraInicial(e.target.value)}
                      value={horaInicial}
                      style={{ width: "100%" }}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>{lang.Fim}</label>
                    <input
                      disabled={IsAdmin.toLocaleLowerCase() != "true"}
                      type="date"
                      onChange={(e) => setDataVencimentoFinal(e.target.value)}
                      value={dataVencimentoFinal}
                      style={{ width: "100%" }}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>{lang.Fim}</label>
                    <input
                      disabled={IsAdmin.toLocaleLowerCase() != "true"}
                      type="time"
                      onChange={(e) => setHoraFinal(e.target.value)}
                      value={horaFinal}
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 ">
                  {!isFolderUpload() && (
                    <div className="d-flex flex-column px-5">
                      <label>Descrição</label>
                      <textarea
                        style={{ color: "#000", padding: 10 }}
                        className="textarea-upload"
                        placeholder="Descrição"
                        rows={4}
                        value={descricao}
                        onChange={(e) => setDescricao(e.target.value)}
                      ></textarea>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </>
        <>
          {arquivoDuplicado && (
            <>
              <div className="container-confirmacao-galeria">
                <img
                  src={icAtencao}
                  style={{ width: 150, height: 150, marginLeft: "46px" }}
                />
                <div className="text-certeza-lixeira">
                  {" "}
                  <span>
                    {
                      lang.Identificamos_arquivos_com_mesmo_nome_na_pasta_de_destino
                    }
                  </span>
                </div>
                <div className="text-aviso-lixeira">
                  <span></span>
                </div>
              </div>

              <div className="container-buttons">
                <button
                  onClick={naoSubstituir}
                  className="button-modal-novo"
                  disabled={loading}
                >
                  {lang.Cancelar}
                </button>
                <button
                  onClick={async () =>
                    await finalizarUpload(botaoParamimTodos, true)
                  }
                  className="buttonConfirmar-modal-novo"
                  disabled={loading}
                >
                  {lang.Substituir}
                </button>
              </div>
            </>
          )}
        </>
      </Modal>
    </div>
  );
};

export default ModalUpload;
